/** AI Product Mapping — confidence display helpers. */

export function confidenceLevel(value: number): 'hi' | 'mid' | 'lo' {
  if (value >= 0.85) return 'hi';
  if (value >= 0.6) return 'mid';
  return 'lo';
}

export function formatPct(value: number): string {
  return `${Math.round(value * 100)}%`;
}
